/** PRODUCT */
export const SINGLE_PRODUCT_INIT = "SINGLE_PRODUCT_INIT";
export const SINGLE_PRODUCT_STORE = "SINGLE_PRODUCT_STORE";

export const FETCH_ALL_PRODUCTS_START = "FETCH_ALL_PRODUCTS_START";
export const FETCH_ALL_PRODUCTS_SUCCESS = "FETCH_ALL_PRODUCTS_SUCCESS";
export const FETCH_ALL_PRODUCTS_FAIL = "FETCH_ALL_PRODUCTS_FAIL";

export const FETCH_MAIN_PRODUCTS_START = "FETCH_MAIN_PRODUCTS_START";
export const FETCH_MAIN_PRODUCTS_SUCCESS = "FETCH_MAIN_PRODUCTS_SUCCESS";
export const FETCH_MAIN_PRODUCTS_FAIL = "FETCH_MAIN_PRODUCTS_FAIL";

export const FETCH_SUB_PRODUCTS_START = "FETCH_SUB_PRODUCTS_START";
export const FETCH_SUB_PRODUCTS_SUCCESS = "FETCH_SUB_PRODUCTS_SUCCESS";
export const FETCH_SUB_PRODUCTS_FAIL = "FETCH_SUB_PRODUCTS_FAIL";

export const SEARCH_PRODUCT_BY_NAME_START = "SEARCH_PRODUCT_BY_NAME_START";
export const SEARCH_PRODUCT_BY_NAME_SUCCESS = "SEARCH_PRODUCT_BY_NAME_SUCCESS";
export const SEARCH_PRODUCT_BY_NAME_FAIL = "SEARCH_PRODUCT_BY_NAME_FAIL";

/* cart */
export const ADD_TO_CART = "ADD_TO_CART";
export const CANCEL_THE_CART = "CANCEL_THE_CART";
export const INCREASE_PRODUCT_QTY = "INCREASE_PRODUCT_QTY";
export const DECREASE_PRODUCT_QTY = "DECREASE_PRODUCT_QTY";
export const ADD_RECEIVER_INFO = "ADD_RECEIVER_INFO";
export const CLEAR_CART = "CLEAR_CART";

/*  orders */
export const ADD_ORDER_INIT = "ADD_ORDER_INIT";
export const ADD_ORDER_START = "ADD_ORDER_START";
export const ADD_ORDER_SUCCESS = "ADD_ORDER_SUCCESS";
export const ADD_ORDER_FAIL = "ADD_ORDER_FAIL";

export const FETCH_ORDERS_START = "FETCH_ORDERS_START";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAIL = "FETCH_ORDERS_FAIL";

/*  AUTH */
export const USER_INIT = "USER_INIT";
export const USER_SIGNUP_START = "USER_SIGNUP_START";
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS";
export const USER_SIGNUP_FAIL = "USER_SIGNUP_FAIL";
export const USER_LOGIN_START = "USER_LOGIN_START";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";
export const AUTH_REDIRECT_PATH = "AUTH_REDIRECT_PATH";
